window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();
      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Global ================*/
/**
 * Global Configurations
 * ------------------------------------------------------------------------------
 */
theme.config = {
  // Media queries & breakpoints based on src/styles/tools/variables.scss.liquid
  mediaQueries: {
    xs: 'screen and (max-width: 29.99em)',
    smallDown: 'screen and (max-width: 47.99em)',
    small: 'screen and (min-width: 30em) and (max-width: 47.99em)',
    smallUp: 'screen and (min-width: 30em)',
    mediumDown: 'screen and (max-width: 63.99em)',
    medium: 'screen and (min-width: 48em) and (max-width: 63.99em)',
    mediumUp: 'screen and (min-width: 48em)',
    largeDown: 'screen and (max-width: 79.99em)',
    large: 'screen and (min-width: 64em) and (max-width: 79.99em)',
    largeUp: 'screen and (min-width: 64em)',
    widescreen: 'screen and (min-width: 80em)'
  },
  breakpoints: {
    small: 480,
    medium: 768,
    large: 1024,
    widescreen: 1280
  }
};
if ((typeof ShopifyAPI) === 'undefined') {
  ShopifyAPI = {};
}

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var $body = $(document.body),
    params = {
      type: 'POST',
      url: '/cart/update.js',
      data: 'note=' + attributeToString(note),
      dataType: 'json',
      beforeSend: function() {
        $body.trigger('beforeUpdateCartNote.ajaxCart', note);
      },
      success: function(cart) {
        if ((typeof callback) === 'function') {
          callback(cart);
        } else {
          ShopifyAPI.onCartUpdate(cart);
        }
        $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
      },
      error: function(XMLHttpRequest, textStatus) {
        $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      },
      complete: function(jqxhr, text) {
        $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
      }
    };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(data, form, callback, errorCallback) {
  var $body = $(document.body),
    params = {
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      beforeSend: function(jqxhr, settings) {
        $body.trigger('beforeAddItem.ajaxCart', form);
      },
      success: function(line_item) {
        if ((typeof callback) === 'function') {
          callback(line_item, form);
        } else {
          ShopifyAPI.onItemAdded(line_item, form);
        }
        $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
      },
      error: function(XMLHttpRequest, textStatus) {
        if ((typeof errorCallback) === 'function') {
          errorCallback(XMLHttpRequest, textStatus);
        } else {
          ShopifyAPI.onError(XMLHttpRequest, textStatus);
        }
        $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
      },
      complete: function(jqxhr, text) {
        $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
      }
    };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  $(document.body).trigger('beforeGetCart.ajaxCart');
  jQuery.getJSON('/cart.js', function(cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    } else {
      ShopifyAPI.onCartUpdate(cart);
    }
    $(document.body).trigger('afterGetCart.ajaxCart', cart);
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var $body = $(document.body),
    params = {
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=' + quantity + '&line=' + line,
      dataType: 'json',
      beforeSend: function() {
        $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
      },
      success: function(cart) {
        if ((typeof callback) === 'function') {
          callback(cart);
        } else {
          ShopifyAPI.onCartUpdate(cart);
        }
        $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
      },
      error: function(XMLHttpRequest, textStatus) {
        $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      },
      complete: function(jqxhr, text) {
        $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
      }
    };
  jQuery.ajax(params);
};

/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function() {
  function Drawer(id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.nodes = {
      $parent: $('html').add('body'),
      $page: $('#page-container')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  }

  Drawer.prototype.init = function() {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
  };

  Drawer.prototype.open = function(evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to nodes.$page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$drawer.prepareTransition();

    this.nodes.$parent.addClass(
      this.config.openClass + ' ' + this.config.dirOpenClass
    );
    this.drawerIsOpen = true;

    // Set focus on drawer
    slate.a11y.trapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    // Run function when draw opens if set
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === 'function'
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();

    return this;
  };

  Drawer.prototype.close = function() {
    if (!this.drawerIsOpen) {
      // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');
    
    if (this.$activeSource) {
      this.$activeSource.attr('aria-expanded', 'false');
    }

    // Ensure closing transition is applied to moved elements, like the nav
    this.$drawer.prepareTransition();

    this.nodes.$parent.removeClass(
      this.config.dirOpenClass + ' ' + this.config.openClass
    );

    this.drawerIsOpen = false;

    // Remove focus on drawer
    slate.a11y.removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    this.unbindEvents();
  };

  Drawer.prototype.bindEvents = function() {
    this.nodes.$parent.on(
      'keyup.drawer',
      $.proxy(function(evt) {
        // close on 'esc' keypress
        if (evt.keyCode === 27) {
          this.close();
          return false;
        } else {
          return true;
        }
      }, this)
    );

    // Lock scrolling on mobile
    this.nodes.$page.on('touchmove.drawer', function() {
      return false;
    });

    this.nodes.$page.on(
      'click.drawer',
      $.proxy(function() {
        this.close();
        return false;
      }, this)
    );
  };

  Drawer.prototype.unbindEvents = function() {
    this.nodes.$page.off('.drawer');
    this.nodes.$parent.off('.drawer');
  };

  return Drawer;
})();

/**
 * Mobile Navigation Script
 * ------------------------------------------------------------------------------
 */

theme.MobileNav = (function() {
	var selectors = {
		mobileNavDrawer: '#mobile-nav-drawer'
	};
	var cache = {};

	function init() {
		cacheSelectors();
		initDrawer();
	}

	function cacheSelectors() {
		cache = {
			mobileNavDrawer: $(selectors.mobileNavDrawer)
		};
	}

	function initDrawer() {
		// Add required classes to HTML
		$('.js-drawer-open-left')
			.attr('aria-controls', 'mobile-nav-drawer')
			.attr('aria-expanded', 'false');

		theme.MobileNavDrawer = new theme.Drawers('mobile-nav-drawer', 'left');
	}

	return {
		init: init
	};
})();

/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {
  'use strict';
  /*global ShopifyAPI, slate, theme, Handlebars, Shopify */

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer;

  /*============================================================================
    PUBLIC METHODS - Initialise the plugin and define global options
  ==============================================================================*/
  function init(options) {

    // Default settings
    settings = {
      formSelector: 'form[action^="/cart/add"]',
      cartContainer: '#CartContainer',
      addToCartSelector: 'input[type="submit"]',
      cartCountSelector: null,
      cartCostSelector: null,
      moneyFormat: '${{amount}}',
      disableAjaxCart: false,
      enableQtySelectors: true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer = $(settings.formSelector);
    $cartContainer = $(settings.cartContainer);
    $addToCart = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector = $(settings.cartCostSelector);

    // General Selectors
    $body = $(document.body);

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      _qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      _formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    _adjustCart();
  }

  function loadCart() {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(_cartUpdateCallback);

  }

  /*============================================================================
    PRIVATE METHODS
  ==============================================================================*/
  function _updateCountPrice(cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(slate.Currency.formatMoney(cart.total_price, settings.moneyFormat));
    }
  }

  function _formOverride() {
    $formContainer.on('submit', function(evt) {
      evt.preventDefault();
      var $form = $(evt.target);

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      var productArray = [];
      var qty = 1;
      var base_id = $form.find('[data-product-select] :selected').val();
      var baseProperties = {};
      var timestamp = Date.now() + Math.random();

      if ($('[js-product-addon-data]').prop('checked')) {
        if ($('[js-product-addon-data]').attr('data-monogram') == '') {
          alert('Please add monogram text to include monogrammed case with this purchase');
          return;
        }
        var regEx = /[^A-Za-z0-9\s]/g;
        var monogram = $('[js-product-addon-data]').attr('data-monogram');
        var monogramColor = $('[js-product-addon-data]').attr('data-monogram-color');
        if (regEx.test(monogram)) {
          alert('Monogram can only contain alphanumeric values. Please remove special characters and try again')
        }else{
          productArray.push(
            {quantity: qty, id: $('#product-addon').val(), properties: {'Monogram': monogram, 'Monogram Color': monogramColor, _timestamp: timestamp }}
          )
          baseProperties._timestamp = timestamp;
        }
      }
      
      if($('[js-addon-lenses]').prop('checked')){
        baseProperties._timestamp = timestamp;
        baseProperties._isBlue = true;
      }

      if($('[js-addon-lenses]').prop('checked')){
        productArray.push(
          {quantity: qty, id: $('[js-addon-lenses]').val(), properties: {_timestamp: timestamp}}
        )
      }

      productArray.push({
        quantity: qty, id: base_id, properties: baseProperties
      })

      var data = { items: productArray };
      ShopifyAPI.addItemFromForm(data, evt.target, _itemAddedCallback, _itemErrorCallback);
    });
  }

  function _itemAddedCallback() {
    $addToCart.removeClass('is-adding').addClass('is-added');

    ShopifyAPI.getCart(_cartUpdateCallback);
  }

  function _itemErrorCallback(XMLHttpRequest, textStatus) {
    var data = JSON.parse(XMLHttpRequest.responseText);
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status === 422) {
        $formContainer.after('<div class="errors qty-error">' + data.description + '</div>');
        console.log(data, textStatus);
      }
    }
  }

  function _cartUpdateCallback(cart) {
    // Update quantity and price
    _updateCountPrice(cart);
    _buildCart(cart);
  }

  function _buildCart(cart) {
    // Start with a fresh cart div
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer
        .append('<p>You have no items in your shopping bag.</p>');
      _cartCallback(cart);
      return;
    }

    // Handlebars.js cart layout
    var items = [],
      item = {},
      data = {},
      source = $("#CartTemplate").html(),
      template = Handlebars.compile(source);

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {
      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
       */
      if (cartItem.image != null) {
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      var displayProperties = JSON.parse(JSON.stringify(cartItem.properties));

      for (var key in displayProperties){
        if (displayProperties.hasOwnProperty(key)) {
          if (key == '_timestamp') {
            delete displayProperties[key]
          }
        }
      }


      // Create item's data object and add to 'items' array
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: displayProperties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: slate.Currency.formatMoney(cartItem.price, settings.moneyFormat),
        vendor: cartItem.vendor,
        linePrice: slate.Currency.formatMoney(cartItem.line_price, settings.moneyFormat),
        originalLinePrice: slate.Currency.formatMoney(cartItem.original_line_price, settings.moneyFormat),
        discounts: cartItem.discounts,
        discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true,
        productType: cartItem.product_type
      };

      for (var key in displayProperties){
        if (displayProperties.hasOwnProperty(key)) {
          if (key == '_isBlue') {
            item.hasBlue = true
            delete displayProperties[key]
          }
        }
      }

      if (cartItem.id == '31831600627747') {
        item.blueLight = true;
      }

      if (cartItem.id == theme.gwpInfo.giftVariantId) {
        cart.gwp = true;
        item.gwp = true;
      }
      
      if (cartItem.id == '31615688572963') {
        item.monogramDetected = true;
      }

      var finalMessageId;
      var finalMessageIdStatic

      if($('[data-variant-id-details]').length > 0) {
        finalMessageId = $('[data-variant-id-details]').data('variantIdDetails');
      }
      
      if($('[data-variant-id-details-static]').length > 0) {
        finalMessageIdStatic = $('[data-variant-id-details-static]').data('variantIdDetailsStatic');
      }

      if($('[data-final-message-js]').length > 0) {
        if (cartItem.id == finalMessageId ) {
          if($('[data-final-message-js]').val() == '<!--split-->') {
            item.finalMessageDetected = true;
            item.finalMessage = ''
          } else {
            item.finalMessageDetected = true;
            item.finalMessage = $('[data-final-message-js]').val()
          }
        }
      }

      if($('[data-final-message-static-js]').length > 0) {
        if (cartItem.id == finalMessageIdStatic ) {
          if($('[data-final-message-static-js]').val() == "<!--split-->") {
            item.finalMessageStaticDetected = true;
            item.finalMessageStatic = '';
          } else {
            item.finalMessageStaticDetected = true;
            item.finalMessageStatic = $('[data-final-message-static-js]').val()
          }
        } 
      }
      items.push(item);
    });

    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      totalPrice: slate.Currency.formatMoney(cart.total_price, settings.moneyFormat),
      totalCartDiscount: cart.total_discount === 0 ? 0 : theme.strings.cartSavings + ' ' + slate.Currency.formatMoney(cart.total_discount, settings.moneyFormat),
      totalCartDiscountApplied: cart.total_discount === 0 ? false : true
    };

    $cartContainer.append(template(data));

    $.ajax({
      url: '/pages/cart-upsell',
      type: "GET",
      dataType: 'html',
      async: false,
      success: function(data) {
        if ($(data).find('.ajaxcart__upsell').length > 0) {
          var $this = $(data).find('.ajaxcart__upsell');
          $this.each(function(i) {
            var upsellContent = $this[i].outerHTML;
            $('.ajaxcart__upsell-append').after(upsellContent);
          });
          var upsellHeader = $(data).find('.ajaxcart__upsell-container')
          $('.ajaxcart__upsell-append').after(upsellHeader);
        }
      }, error: function(data) {
        console.log('error retrieving data: ' + data);
      }
    });

    _cartCallback(cart);
  }

  function _cartCallback(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('afterCartLoad.ajaxCart', cart);

    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  }

  function _adjustCart() {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
        line = $el.data('line'),
        $qtySelector = $el.siblings('.ajaxcart__qty-num'),
        qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = _validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else if ($el.hasClass('ajaxcart__qty-remove')){
        qty = 0;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
        line = $el.data('line'),
        qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = _validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');
      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, _adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  }

  function _adjustCartCallback(cart) {
    // Update quantity and price
    _updateCountPrice(cart);

    _checkTimestamp(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      isUpdating = false;
      ShopifyAPI.getCart(_buildCart);
    }, 150);
  }

  function _checkTimestamp(cart) {
    console.log('check timestamp')
    var timestamps = []

    $.each(cart.items, function(index, cartItem) {
      var timestamp = cartItem.properties._timestamp
      if(typeof timestamp !== 'undefined' && timestamps.indexOf(timestamp) < 0 && (cartItem.id != 31831600627747 && cartItem.id != 31615688572963)){
        timestamps.push(timestamp);
      }
    })
    console.log('check timestamp', timestamps)

    $.each(cart.items, function(index, cartItem) {
      if(cartItem.id == 31831600627747 || cartItem.id == 31615688572963){
        if(timestamps.indexOf(cartItem.properties._timestamp) < 0){
          var line = index + 1;
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: 'quantity=0&line=' + line,
            dataType: 'json',
            async: false,
            success: function(cart){
              _adjustCartCallback(cart)
            }
          })
        }
      }
    })
  }

  function _createQtySelectors() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
          currentQty = $el.val();

        var itemAdd = currentQty + 1,
          itemMinus = currentQty - 1,
          itemQty = currentQty;

        var source = $("#AjaxQty").html(),
          template = Handlebars.compile(source),
          data = {
            key: $el.data('id'),
            itemQty: itemQty,
            itemAdd: itemAdd,
            itemMinus: itemMinus
          };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  }

  function _qtySelectors() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
          currentQty = $el.val(),
          inputName = $el.attr('name'),
          inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
          itemMinus = currentQty - 1,
          itemQty = currentQty;

        var source = $("#JsQty").html(),
          template = Handlebars.compile(source),
          data = {
            key: $el.data('id'),
            itemQty: itemQty,
            itemAdd: itemAdd,
            itemMinus: itemMinus,
            inputName: inputName,
            inputId: inputId
          };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
          id = $el.data('id'),
          $qtySelector = $el.siblings('.js-qty__num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = _validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  }

  function _validateQty(qty) {
    if ((parseFloat(qty) === parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  }

  module = {
    init: init,
    load: loadCart
  };

  return module;

}(ajaxCart || {}, jQuery));

window.theme = window.theme || {};

theme.CartDrawer = new theme.Drawers('CartDrawer', 'right', {
  onDrawerOpen: ajaxCart.load
});

// Init ajax cart
ajaxCart.init({
  formSelector: '.product-form',
  cartContainer: '#CartContainer',
  addToCartSelector: '.product-form__cart-submit',
  cartCountSelector: '.cart-count',
  moneyFormat: theme.moneyFormat
});

// Promo Bar in Ajax Cart
$("body").on("click", ".ajaxcart__promo-submit" , function(e){
  e.preventDefault()
  var $inputVal = $(".ajaxcart__promo-input").val();
  var $location = "/checkout?discount=" + $inputVal
  if ( $inputVal != ""){
    $(location).attr("href", $location)
  }
})

// Bind to 'afterCartLoad.ajaxCart' to run any javascript after the cart has loaded in the DOM
jQuery(document.body).on('afterCartLoad.ajaxCart', function(evt, cart) {
  theme.CartDrawer.open();

  var giftAvailable = theme.gwpInfo.giftAvailable;
  var giftId = theme.gwpInfo.giftVariantId;
  var requiredCollection = theme.gwpInfo.requiredCollection.split(','); 
  var giftPresentInCart = false;
  var itemPresentInCart = false
  if(cart.gwp == true) {
    giftPresentInCart = true;
  }

  if(giftAvailable && giftId) {

    if(giftPresentInCart == false) {
      for(var i = 0; i < cart.items.length; i++) {
        if(requiredCollection.includes(cart.items[i].product_type)) {
          var data = {
            quantity: 1,
            id: giftId
          }
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: data,
            success: function(cart) {
              ajaxCart.load();
            },
            error: function() {
              console.log('Error')
              ajaxCart.load()
            }
          })
          break;
        } 
      }
    } else {
      for(var j = 0; j < cart.items.length; j++) {
        if(requiredCollection.includes(cart.items[j].product_type)) {
          itemPresentInCart = true
          break;
        } else {
        }
      }

      if(itemPresentInCart == false) {
        var data = {
          quantity: 0,
          id: giftId
        }
        $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          dataType: 'json',
          data: data,
          success: function(cart) {
            ajaxCart.load();
          },
          error: function() {
            console.log('Error')
            ajaxCart.load()
          }
        })
      }
    }

  }




  $('[upsell-js]').each(function(){
    var productId = $(this).data('product-id');
    var form = '[upsell-js-' + productId + ']'
    new theme.AjaxUpsell(form);
  })

  $('[js-upsell-buy]').click(function(e){
    e.preventDefault();
    var $el = $(e.currentTarget);
    var upsellId = $('[data-product-select]', $el.parent().parent()).val();
  
    var data = {
      quantity: 1,
      id: upsellId
    }
  
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: data,
      success: function(cart) {
        ajaxCart.load();
      },
      error: function() {
        console.log('Error')
        ajaxCart.load()
      }
    })
  })
});

theme.Accordion = (function(){
  var selectors = {
    header: '[js-accordion-header]',
    content: '[js-accordion-content]'
  }

function Accordion(container) {
    this.$container = $(container);
    this.$header = $(selectors.header, this.$container)
    this.$content = $(selectors.content, this.$container)

    this.$header.on('click', toggleAccordion.bind(this));

    function toggleAccordion(evt) {
      var $el = $(evt.currentTarget)
      if($el.attr('aria-expanded') == 'true'){
        //this stops the slide up triggering the parent;
        $el.siblings().slideUp(400, function() {
          $(this).attr('aria-hidden', true);
        })
        // This is closing the children accordions when the parent accordion is closed.
        $el.siblings(selectors.content).find(selectors.header).each(function(){
              $(this).attr('aria-expanded', false);
              $(this).siblings(selectors.content).slideUp(400, function() {
                  $(this).attr('aria-hidden', true);
              });
        })
        $el.attr('aria-expanded', false);
      } else {
        $el.parent().siblings().children(selectors.content , this.$container).slideUp(400, function(){
          $(this).attr('aria-hidden', true);
        });
        $el.parent().siblings().children(selectors.header , this.$container).attr('aria-expanded', false);
        $el.siblings(selectors.content).slideDown().attr('aria-hidden', false);
        $el.attr('aria-expanded', true);
      }
    }
  }

  return Accordion;
})();

/**
* Swatches Script
* ------------------------------------------------------------------------------
*/

theme.swatches = (function() {
    if (!$('.swatch').length) {
      return;
    }
   
    var $swatchInput = $('[data-swatch-input]');
    var namespace = '.swatch';
   
    $swatchInput.on('change' + namespace, updateSingleOptionSelector);
   
    function updateSingleOptionSelector(evt) {
      var $el = $(evt.currentTarget);
      var optionIndex = $el.closest('.swatch').attr('data-option-index');
      var optionValue = $el.val();
   
      $el.closest('form')
        .find('[data-single-option-selector]')
        .eq(optionIndex)
        .val(optionValue)
        .trigger('change');
    }
    
    // Selecting Correct Swatch on load
    $(".selector-wrapper").each(function(){
        var $selected = $(this).find("select option:selected").val()
        $(".swatch-element[data-value='" + $selected + "'] input").prop("checked", true)
    })

    $('[js-swatch-label], .header').keypress( function( e ) {
        var $this = $(this);
          var code = e.keyCode || e.which;
          if( code === 13 ) {
            $this.trigger("click")
          }
    })

    if( $(".color-header").length < 1 || $(".swatch-each").hasClass("swatch-each--color-one-variant")){
        $(".selector-wrapper--other").addClass("selector-wrapper--other-alone");
    }
    
    enquire.register(theme.config.mediaQueries.mediumDown, {
        match: function(){
            $(".header").each(function(){
                $(this).attr("tabindex", 0)
            })
            // Swapping out placeholder for currently selected swatch info
            // if(window.location.href.indexOf('?variant=') > 0) {
                var $selectedVariants = $("[data-swatch-input]:checked").parent(".swatch-element");
                $selectedVariants.each(function(){
                    $selectedVariants.addClass("active");
                    var $value = $(this).attr("data-value");
                    var $img = $(this).attr("data-img");
                    if ($(this).hasClass("color")){
                        if( $img !== undefined ){
                            $(".color-header").html("<div class='color-header__img-border'><div class='color-header__img' style='background-image:url("+ $img + ")'></div></div><div class='color-header__text'>" + $value + "</div>").addClass("selected");
                        }
                    }
                    else{
                        $(".size-header").html("<span class='size-header'>" + $value + "</span>").addClass("selected");
                    }
                })
            // }
            // Close swatch dropdowns
            $(".header").click(function(e){
                if ( $(this).next(".swatch-selection").hasClass("active")){
                    $(".swatch-selection").removeClass("active");
                }
                else{
                    $(".swatch-selection").removeClass("active")
                    var $swatchContent = $(this).next(".swatch-selection")
                    $swatchContent.addClass("active");
                }
            })
            $(document).click( function() {
                $(".swatch-selection").removeClass("active")
            });
            $(".swatch-selection, .swatch .header").click( function(e) {
                e.stopPropagation();
            });
            // Checking how many variant there are.
            function headerCount(){
                var count = 0;
                var headerCount = 0;
                $(".swatch .header").each(function(){
                    if ( $(this).hasClass("selected")){
                        count = count + 1;
                    }
                    headerCount = headerCount + 1;
                })
                if ( headerCount > 1 ){
                    if ( count === 2){
                        $(".product-info__add-to-cart").attr("disable", false)
                    }
                    else{
                        $(".product-info__add-to-cart").attr("disable", true)
                    }
                }
                else {
                    if ( count === 1){
                        $(".product-info__add-to-cart").attr("disable", false)
                    }
                    else{
                        $(".product-info__add-to-cart").attr("disable", true)
                    }
                }
            }
            // Color Swatch
            $(".swatch-element").click(function(){
                var $parent = $(this).parent(".swatch-selection");
                var $currentActive = $parent.find(".swatch-element.active");
                var $val = $(this).attr("data-value")
                var $imgsrc=  $(this).attr("data-img");
                if ( $(this).hasClass("color")){
                    $(".color-header").html("<div class='color-header__img-border'><div class='color-header__img' style='background-image:url("+ $imgsrc + ")'></div></div><div class='color-header__text'>" + $val + "</div>").addClass("selected");
                }
                if ( $(this).hasClass("other-variant")){
                    $(".size-header").html("<span class='size-header'>" + $val + "</span>").addClass("selected");        
                }
                $currentActive.removeClass("active");
                $(this).addClass("active");
                $(".swatch-selection").removeClass("active");
                headerCount();
            })
            headerCount();

            if( $(".color-header").length < 1 ){
                $(".size-header").addClass("size-header--alone")
                $(".swatch-each").addClass("swatch-each--full");
            }
            if( $(".size-header").length < 1 ){
                $(".color-header").addClass("color-header--alone");
                $(".swatch-each").addClass("swatch-each--full");
            }
            
        },
        unmatch: function(){
            $(".header").each(function(){
                $(this).removeAttr("tabindex")
            })
            $(".swatch-element.color").off("click")
            $(".swatch-element.other-variant").off("click")
            $(".header").off("click")
            $(".size-header").html("Size")
            $(".color-header").html("Color <span class='color-header__color'></span>")
            $(".swatch-element").removeClass("active");
            $(".product-info__add-to-cart").attr("disable", false)
            $(".selector-wrapper").each(function(){
                var $selected = $(this).find("select option:selected").val()
                $(".swatch-element[data-value='" + $selected + "'] input").prop("checked", true)
            })
        }
    })
})();
   
// Quick add is good for collection / related products / featured products

// Selecting Swatches
$("body").on("click", ".product-card__swatch-border", function(){
    var $this = $(this);
    var variantId = $this.attr("data-variant-id");
    var $productCard = $this.closest(".product-card");
    var $quickAddButton = $productCard.find("[quick-add-product]");
    var $priceElement = $productCard.find(".product-card__price")
    var $swatchName = $this.attr("data-swatch-name");
    var $productName = $this.attr("data-product-name");
    var $price = $this.attr("data-variant-price")
    var $comparePrice = $this.attr("data-compare-price")
    var $available = $this.attr("data-available");
    $quickAddButton.attr("data-variant-id", variantId);
    $productCard.find(".product-card__swatch-border, .product-card__image.active").removeClass("active");

    $this.addClass("active");
    
    var $image = $productCard.find(".product-card__image[data-image-info='" + $productName + '--' + $swatchName + "']")
    
   
    $image.each(function(index){
        if ( index === 0 ){
            $(this).addClass("active");
        }

        if ( index === 1 ) {
            if($(this).data('src') == 'undefined') {
                console.log('undefined')
            } else {
                $(this).addClass("product-card__secondary-image");
            }
        }
    })

    

    if ( $image.length < 1 ){
        $productCard.find(".product-card__image[data-image-info='featured-image']").addClass("active");
    }      
    // Adjusting Price
    var $price = parseInt($price) / 100
    if ( $comparePrice != undefined ){
        var $comparePrice = parseInt($comparePrice) / 100
        var $twoPrices = '$'+$price+'<span class="product-card__compare-price">$'+$comparePrice+'</span>'
        $priceElement.html($twoPrices)
    }
    else{
        $priceElement.text('$'+$price)
    }


    // Adjusting Quick Add depending on availability
    if ( $available === "true" ){
        $quickAddButton.html('Add to Bag <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 31.49 31.49" style="enable-background:new 0 0 31.49 31.49;" xml:space="preserve"><path style="fill:#1E201D;" d="M21.205,5.007c-0.429-0.444-1.143-0.444-1.587,0c-0.429,0.429-0.429,1.143,0,1.571l8.047,8.047H1.111 C0.492,14.626,0,15.118,0,15.737c0,0.619,0.492,1.127,1.111,1.127h26.554l-8.047,8.032c-0.429,0.444-0.429,1.159,0,1.587 c0.444,0.444,1.159,0.444,1.587,0l9.952-9.952c0.444-0.429,0.444-1.143,0-1.571L21.205,5.007z"/></svg>').removeClass("product-card__sold-out");
    }
    else{
        $quickAddButton.html('Sold Out').addClass("product-card__sold-out")
    }
})
//  Quick add Functionality
$("body").on("click", "[quick-add-product]", function(evt){
    evt.preventDefault();
    var variantId = $(this).attr("data-variant-id");
    var properties = {}
    var data = {
        quantity: 1,
        id: variantId,
        properties: properties
    }
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data:  data,
        id: variantId,
        quantity: 1,
        error: function(){
            console.log("error")
        },
        success: function(){
            if ( $("body").hasClass("template-cart")){
                if ( $(".ajaxcart__update").length > 0 ){
                    $(".ajaxcart__update").trigger("click");
                }
            }
            else{
                ajaxCart.load();
            }
        }
    })
})

/**
 * Product Form script
 * ------------------------------------------------------------------------------
 * Creates a product form with selectable options
 * @constructor
 * @param {string} form - selector for the form DOM element
 * @param {object} options - Object containing options to override defaults
 * @param {object} options.strings - Text copy of
 */
theme.AjaxUpsell = (function() {
  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text-ajax]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper-ajax]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price-ajax]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  }

  function AjaxUpsell(form, options) {
    var $form = this.$form = $(form);
    if (!$(selectors.productJson, this.$form).html()) {
      console.error('Failed to parse JSON - Missing Product JSON object');
      return;
    }
    
    this.namespace = '.ajaxcart__upsell';
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$form).html());
    var variantOptions = {
      $container: this.$form,
      enableHistoryState: this.$form.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };
    this.variants = new slate.Variants(variantOptions);
    this.$form.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$form.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    var $swatchInput = $('[data-swatch-input-ajax]');
    var namespace = '.ajax-swatch';
   
    $swatchInput.on('change' + namespace, updateAjaxSingleOptionSelector);
    $swatchInput.on('change' + namespace, updateAjaxPicture);
   
    function updateAjaxSingleOptionSelector(evt) {
      var $el = $(evt.currentTarget);
      var optionIndex = $el.closest('.ajax-swatch').attr('data-option-index');
      var optionValue = $el.val();

      $el.closest('.ajaxcart__upsell-inner' ,'.ajaxcart__upsell-options')
        .find('[data-single-option-selector]')
        .eq(optionIndex)
        .val(optionValue)
        .trigger('change');

    }

    function updateAjaxPicture(evt) {
      var $el = $(evt.currentTarget);
      
      var imageSrc = $el.attr('data-ajax-image');
      var currentImage = $el.parents('.ajaxcart__product-information').siblings('.ajaxcart__product-image').children('.ajaxcart__product-image-src');

      if(imageSrc.includes('no-image')) {
        console.log('No image found');
      } else {
        currentImage.attr("src", imageSrc);
      }

    }
  }
  AjaxUpsell.prototype = $.extend({}, AjaxUpsell.prototype, {
    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$form);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$form);
      $(selectors.productPrice, this.$form).html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));
      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },
    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;
      if (variant) {
        $(selectors.addToCartText, this.$form).prop('disabled', false);
        $(selectors.addToCartText, this.$form).html('ADD');
      } else {
        $(selectors.addToCartText, this.$form).prop('disabled', true);
        $(selectors.addToCartText, this.$form).html('UNAVAILABLE');
        $(selectors.priceWrapper, this.$form).addClass('hide');
        return;
      }
      if (variant.available) {
        $(selectors.addToCart, this.$form).prop('disabled', false);
        $(selectors.addToCartText, this.$form).html('ADD');
      } else {
        $(selectors.addToCart, this.$form).prop('disabled', true);
        $(selectors.addToCartText, this.$form).html('UNAVAILABLE');
      }
    }
  });

  return AjaxUpsell;
})();



/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);
    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantChange' + this.namespace, this.updateFinalMessage.bind(this));
    this.$container.on('variantChange' + this.namespace, this.updateSwatchHidden.bind(this));
    this.$container.on('variantChange' + this.namespace, this.hideSwatch.bind(this));
    this.$container.on('variantChange' + this.namespace, this.updateMonogram.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
    this.slickProductImage();
    this.$container.on('variantChange' + this.namespace, this.filterImages.bind(this));
    this.$container.trigger({
      type: 'variantChange' + this.namespace,
      variant: this.variants.currentVariant
    });
    this.triggerAffirm();
    this.relatedProducts();
    this.differentCountries();
    this.forceBiS();

    $('[js-product-addon-text-input]').on('keyup', function(){
      $('[js-product-addon-text-overlay]').html($(this).val());
      $('[js-product-addon-data]').attr('data-monogram', $(this).val().toUpperCase());
    })

    $('[name="product-addon-text-color"]').on('change', function(){
      var color = $('[name="product-addon-text-color"]:checked').val()
      var colorName = $('[name="product-addon-text-color"]:checked').data('color');
      $('[js-product-addon-text-overlay]').css('color', color);
      $('[js-product-addon-data]').attr('data-monogram-color', colorName);
      $('[js-product-addon-color-name]').html(colorName);
    })

    var $addonModal = $('[js-addon-modal]').remodal();

    $('[js-product-addon-data]').on('click', function(){
      if ($(this).prop('checked')){
        $addonModal.open();
      }
    })

    var $sizeModal = $('[js-size-guide-modal]').remodal();

    $('[js-toggle-size-modal]').on('click', function(e){
      e.preventDefault();
      $sizeModal.open();
    })

    var $footModal = $('[js-foot-guide-modal]').remodal();

    $('[js-toggle-foot-modal]').on('click', function(e){
      e.preventDefault();
      $footModal.open();
    })


  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;
      if($('[data-preorder-ids]').length) {
        var atc_to_preorder = $('[data-preorder-ids]').data('preorder-ids');
        var atc_array = atc_to_preorder.split(',')
      }

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        for(var i = 0; i < atc_array.length; i++) {
          if(atc_array[i] == variant.id) {
            $(selectors.addToCart, this.$container).prop('disabled', false);
            $(selectors.addToCartText, this.$container).html('Preorder Now');
            break;
          } else {
            $(selectors.addToCart, this.$container).prop('disabled', false);
            $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
          }
        }
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        var hiddenVariants = $('[data-hidden-variants-metafield]').data('hiddenVariantsMetafield').slice(0, -1).split(',');
        for(var i = 0; i < hiddenVariants.length; i++ ) {
          var tuple = hiddenVariants[i].split('--');
          if(tuple[0] == variant.option1 && tuple[1] == variant.option2 ) {
            $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
          } else {
            $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
          }
        }
      } 


    },

    hideSwatch: function(evt) {
      var hiddenSwatches = $('[data-hidden-variants-all]').data('hiddenVariantsAll').split(',')

      var swatches = $('[js-each-swatch]')
      swatches.each(function(){
        if(hiddenSwatches.includes($(this).data('hideSwatch'))) {
          $(this).attr('data-hide-everywhere', "true");
        }
      })
    },

    updateSwatchHidden: function(evt) {
      var variant = evt.variant

      //Get data of colors and hidden variants
      var $hiddenVariants = $('[data-hidden-variants-metafield]').data('hiddenVariantsMetafield').slice(0, -1).split(',');
      var $colorOptions = $('[data-hidden-variants-metafield]').data('allColorVariants').slice(0, -1).split(',');
      var $sizeOptions = $('[data-hidden-variants-metafield]').data('allSizesVariants').slice(0, -1).split(',');
      var $singleOptionSelector = $('[data-variant-option-2]');
      var sizes = [];


      $singleOptionSelector.each(function(){
        var sizeData = $(this).attr('data-variant-option-2');
        if(sizes.includes(sizeData)) {
          //do nothing
        } else {
          sizes.push(sizeData)
        }
      })

      var sizesUnfound = $sizeOptions.filter(function(obj) { 
        return sizes.indexOf(obj) == -1; 
      });


      //Set up tuple object of sizes and colors
      var hiddenColors = {};

      for(var i = 0; i < $sizeOptions.length; i++) {
        hiddenColors[$sizeOptions[i]] = []
      }

      //Hide and show depending on hidden variants
      $('[data-hide-swatch-value]').each(function(){
        $(this).css('display', 'flex');
      })
      for(var i = 0; i < $hiddenVariants.length; i++ ) {
        var tuple = $hiddenVariants[i].split('--');

        for(key in hiddenColors) {
          if(key == tuple[1]) {
            hiddenColors[key].push(tuple[0])
          }
        }

        if(tuple[1] == variant.option2 ) {
          $('[data-hide-swatch-value="'+tuple[0]+'"]').hide();
        } else {
          //do nothing
        }
      }


      //Hide size selector if all swatches are hidden
      // for(key in hiddenColors) {
      //   var the_same = hiddenColors[key].length == $colorOptions.length && hiddenColors[key].every(function(element, index){
      //     return element == $colorOptions[index];
      //   })

      //   if(the_same) {
      //     $('[data-size-available="'+key+'"]').hide();
      //   }
      // }

      if(sizesUnfound.length) {
        for(var i = 0; i < sizesUnfound.length; i++) {
          $('[data-size-available="'+sizesUnfound[i]+'"]').hide();
        }
      } else {
        console.log('there is a variant for each size')
      }
    },

    updateFinalMessage: function(evt) {
      var $variantId = evt.variant.id;
      
      $(".product__final-message").each(function(){
        $(this).removeClass("appear");
      })
      $(".product__final-message[data-variant-id-details='" + $variantId + "']").addClass("appear");

    },

    updateMonogram: function(evt) {
      var variant = evt.variant;
      var $toggleContainer = $('.product-addon__toggle-container', this.$container);
      if(variant.name.includes("SOFT CASE")) {
        if(variant.option1 == 'Brown') {
          if($toggleContainer.hasClass('hidden-toggle')) {
            $toggleContainer.removeClass('hidden-toggle');
          } else {
            //Do nothing
          }
        } else {
          if($toggleContainer.hasClass('hidden-toggle')) {
            //Do nothing
          } else {
            $toggleContainer.addClass('hidden-toggle');
          }
        }
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);
      this.$featuredImage.attr('src', sizedImgUrl);
    },
    // Featured Product Images and Thumbnail images.
    slickProductImage: function(evt){
      $("[js-slick-featured-product-image]").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: '[js-slick-product-thumbnail-image]',
        nextArrow: '<button class="featured-image__next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="13" height="26" viewBox="0 0 13 26"><g fill="none" fill-rule="evenodd"><path fill="none" d="M-1373-1449H67v4131h-1440z"/><path fill="currentColor" fill-rule="nonzero" d="M1.861 25.094L13 12.594 1.861.094 0 1.706l9.703 10.888L0 23.482z"/></g></svg></button>',
        prevArrow: '<button class="featured-image__prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="13" height="26" viewBox="0 0 13 26"><g fill="none" fill-rule="evenodd"><path fill="none" d="M-62-1449h1440v4131H-62z"/><path fill="currentColor" fill-rule="nonzero" d="M11.139 25.094L0 12.594 11.139.094 13 1.706 3.297 12.594 13 23.482z"/></g></svg></button>',
        infinite: false
      })
      $("[js-slick-product-thumbnail-image]").slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        asNavFor: '[js-slick-featured-product-image]',
        focusOnSelect: true,
        infinite: false
      })
      // Lifesyle Images
      enquire.register(theme.config.mediaQueries.largeUp, {
        match: function(){
          if ( $("[js-lifestyle-images-slick]").hasClass("slick-initialized")){
            $("[js-lifestyle-images-slick]").slick("unslick");
          }
          $("[js-lifestyle-images-slick]").slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            nextArrow: '<button class="lifestyle-image__next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="13" height="26" viewBox="0 0 13 26"><g fill="none" fill-rule="evenodd"><path fill="#FFF" d="M-1373-1449H67v4131h-1440z"/><path fill="currentColor" fill-rule="nonzero" d="M1.861 25.094L13 12.594 1.861.094 0 1.706l9.703 10.888L0 23.482z"/></g></svg></button>',
            prevArrow: '<button class="lifestyle-image__prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="13" height="26" viewBox="0 0 13 26"><g fill="none" fill-rule="evenodd"><path fill="#FFF" d="M-62-1449h1440v4131H-62z"/><path fill="currentColor" fill-rule="nonzero" d="M11.139 25.094L0 12.594 11.139.094 13 1.706 3.297 12.594 13 23.482z"/></g></svg></button>'
          })
        },
        unmatch: function(){
        }
      }).register(theme.config.mediaQueries.mediumDown, {
        match: function(){
          if ( $("[js-lifestyle-images-slick]").hasClass("slick-initialized")){
            $("[js-lifestyle-images-slick]").slick("unslick");
          }
          $("[js-lifestyle-images-slick]").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            nextArrow: '<button class="lifestyle-image__next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="13" height="26" viewBox="0 0 13 26"><g fill="none" fill-rule="evenodd"><path fill="none" d="M-1373-1449H67v4131h-1440z"/><path fill="currentColor" fill-rule="nonzero" d="M1.861 25.094L13 12.594 1.861.094 0 1.706l9.703 10.888L0 23.482z"/></g></svg></button>',
            prevArrow: '<button class="lifestyle-image__prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="13" height="26" viewBox="0 0 13 26"><g fill="none" fill-rule="evenodd"><path fill="none" d="M-62-1449h1440v4131H-62z"/><path fill="currentColor" fill-rule="nonzero" d="M11.139 25.094L0 12.594 11.139.094 13 1.706 3.297 12.594 13 23.482z"/></g></svg></button>'
          })
        },
        unmatch: function(){
        }
      })
    },
    filterImages: function(e){  
      // Showing correct Product Details
      var $variantId = e.variant.id;
      $(".product-info__details-content").each(function(){
        $(this).removeClass("appear");
      })
      $(".product-info__details-content[data-details='" + $variantId + "']").addClass("appear");
    

      var $data;
      var $sizeData = $(".selector-wrapper--other select option:selected").val();
      if ( $(".input-color[data-swatch-input]:checked").length > 0 ){
        $data = $(".input-color[data-swatch-input]:checked").val().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
      }
      else{
        if ( $sizeData != undefined ){
          $data = $sizeData.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
        }
      }
      // Checking if any images have an alt tag
      var $handle = $(".product-top").attr("data-handle")
      var tagsFound = false;
      $(".product-image__thumbnail").each(function(){
        var $alt = $(this).attr("alt")
        if ( $alt != $handle ){
          tagsFound = true;
        }
      })

      if ( tagsFound == true ){
        $("[js-slick-featured-product-image]").slick("slickUnfilter")
        $("[js-slick-featured-product-image]").slick("slickFilter", function(i, element){
          var $handleizedAlt = $(element).attr("alt");
          var $normalAlt = $(element).attr("normalAlt");
          var $handleizedColor = $(element).attr("data-image-variant-name");
          if (  $handleizedAlt.indexOf("split") > 1   ){
            var $firstAlt = $handleizedAlt.split("split")[0];
            var $url = $normalAlt.split("split")[1];
            if ( $firstAlt == $data || $firstAlt == "global" ){
              return $(element).html('<div class="product-image__video-wrapper"><video loop autoplay muted playsinline width="320" height="240"><source src="'+$url+'" type="video/mp4"><source src="'+$url+'" type="video/ogg">Your browser does not support the video tag.</video></div>')
            }
          }
          else{
            if($handleizedColor) {
              return $handleizedColor == $data || $handleizedColor == "global"
            } else {
              return $handleizedAlt == $data || $handleizedAlt == "global"
            }
          }
        })   
        $("[js-slick-product-thumbnail-image]").slick("slickUnfilter")
        $("[js-slick-product-thumbnail-image]").slick("slickFilter", function(i, element){
          var $alt = $(element).attr("alt");
          var $imageVariantName = $(element).attr("data-image-variant-name");
          if (  $alt.indexOf("split") > 1   ){
            var $firstAlt = $alt.split("split")[0];
            return $firstAlt == $data || $firstAlt == "global"
          }
          else{
            if($imageVariantName) {
              return $imageVariantName == $data || $imageVariantName == "global"
            } else {
              return $alt == $data || $alt == "global"
            }
          }
        })   
        // Reindexing Slides on variant change
        var $featuredSlides = $("[js-slick-featured-product-image]").find('.slick-slide');
        var $thumbnailSlide = $("[js-slick-product-thumbnail-image]").find(".slick-slide");
        $featuredSlides.each(function (i) {
          $(this).attr('data-index', i);
          $(this).attr('data-slick-index', i);
        })
        $thumbnailSlide.each(function (i) {
          $(this).attr('data-index', i);
          $(this).attr('data-slick-index', i);
        })
        $("[js-slick-featured-product-image]").slick('slickGoTo', 0, true)
        $("[js-slick-product-thumbnail-image]").slick('slickGoTo', 0, true)

      }

      var imageLength = $(".featured-images__each").length;
      if ( imageLength < 5 ){
        $("[js-slick-product-thumbnail-image] .slick-track").addClass("stay")
      }
      else{
        $("[js-slick-product-thumbnail-image] .slick-track").removeClass("stay")
      }

      // Get tooltip text next to color label
      $(".color-header__color").text(": "+$(".input-color:checked").val())
      
    },
    triggerAffirm: function(){
      $("body").on("click", ".product-info__affirm-trigger", function(){
        $(".affirm-modal-trigger").trigger("click")
      })
    },
    differentCountries: function(){
      GeolizrAPI.addEventListener('geolizr.geoData', function(geoData) {
        if ( geoData.currencyCode != 'USD' ){
          $(".header-right__cart, .product-info__add-to-cart, [data-product-price], [data-compare-text], [data-compare-price], .affirm-as-low-as").hide();
          $(".product-info__only-us").show();
        }
        if ( geoData.currencyCode == 'CHF' ){
          $(".product-card__price").hide();
          $(".product-info__switz-price").show();
        }
        else if ( geoData.currencyCode == 'AUD' ){
          $(".product-card__price").hide();
          $(".product-info__aus-price").show();
        }
      });
    },
    relatedProducts: function(e){
      GeolizrAPI.addEventListener('geolizr.geoData', function(geoData) {
        if ( geoData.currencyCode != 'USD' ){
          $(".product-card__quick-add-trigger, .product-promo_message, .promo_message").hide();
        }
      });
    },
    forceBiS: function(e){
      setTimeout(function(){ 
        var $forceHideData = $('[data-initial-variant-bis]').data('initialVariantBis');
        if ($forceHideData == true) {
          var $forceHide = $('[data-initial-variant-bis]');
          var $forceShow = $('.klaviyo-bis-trigger');
          $forceHide.hide();
          $forceShow.show();
        } else {
          console.log('initial-in-stock')
        }
      }, 500);
    },
    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();

theme.Collection = (function(){
    function Collection(container) {
        // Triggering Filter
        $("body").on("click", ".collection-top__filter-trigger", function(){
            $(".collection-filter__dropdown").slideToggle();
        })
        // Close collection filter
        $("body").on("click", ".collection-filter__close", function(){
            $(".collection-top__filter-trigger").trigger("click");
        })

        $('.bc-sf-filter-option-item').on("click", function(){
            
        })
    }
    return Collection;
})();
theme.Header = (function() {
  function header() {
    $('.header-mobile-icon').on('click', function() {
      $('.nav').toggleClass('show-nav');

      $('.header-mobile-menu').toggleClass('hide-menu-icon');
      $('.header-mobile-close').toggleClass('hide-menu-icon');
    });

    $('.header-nav__link').each(function () {
      $(this).on('click', function () {
        var submenu = $(this).data('link');

        $('.header-subnav__' + submenu).addClass('show-submenu');
        $('.site-nav--has-submenu').not($('.header-subnav__' + submenu)).removeClass('show-submenu');
        $('.header-nav__link').find("span").removeClass('mobile-nav-active');
        $(this).find("span").addClass('header-nav__active');
        $('.header-nav__link').find("span").not($(this).find("span")).removeClass('header-nav__active');
      });
    });

    $(".header-nav__link--mobile").click(function(){
      $(".header-nav__link--mobile.mobile-nav-active").removeClass("mobile-nav-active")
      $(this).addClass("mobile-nav-active")
    })

    // hide mobile nav if click event occurs outside of parent element
    $(document).on('click', function(event) {
      if (!$(event.target).closest('.header-wrapper').length) {
        if ($('.nav').hasClass('show-nav')) {
          $('.nav').removeClass('show-nav');
          $('.header-mobile-menu').removeClass('hide-menu-icon');
          $('.header-mobile-close').addClass('hide-menu-icon');
        }
      }
    });

    // go to stores page when stores dropdown is changed
    $('.header-right__stores').on('change', function() {
      window.location.href = $(this).val();
    });

    GeolizrAPI.addEventListener('geolizr.geoData', function(geoData) {
      // Europe Switzerland or Australia
      if ( geoData.currencyCode != 'USD' ){
        $(".header-right__cart").hide();
      }
    });

  }

  $(".header-right__search--mobile").click(function(){ 
    $("#bc-sf-search-box-0").focus() 
  })

  return header();
})();

theme.Search = new theme.Drawers('Search', 'top', {});
theme.HeroSlider = (function(){
    var selectors = {
        slider: '[hero-slick-js]'
    }

    function HeroSlider(container) {
        this.$container = $(container);
        var $slider = $(selectors.slider, this.$container);
        var autoplay = $slider.attr("js-autoplay");
        if (autoplay == 'false' ){
            autoplay = false
        }
        else{
            autoplay = true
        }
        var autoplaySpeed = $slider.attr("js-autoplay-speed") * 1000;

        GeolizrAPI.addEventListener('geolizr.geoData', function(geoData) {
            if ( geoData.currencyCode != 'USD' ){
                $(".hero-slider__slide-container--holiday").remove()
            }
        });
        
        $slider.slick({
                infinite: true,
                dots: true,
                arrows: false,
                autoplay: autoplay,
                autoplaySpeed: autoplaySpeed,
                adaptiveHeight: true
        });
       
    }

    return HeroSlider;
})();
theme.ProductHighlight = (function() {
  function productHighlight() {
    enquire.register(theme.config.mediaQueries.smallDown, {
      match: function() {
        if ($('.highlight-image').hasClass('slick-initialized')) {
          $('.highlight-image').slick('unslick');
        }

        $('.highlight-image').slick({
          arrows: false,
          dots: true,
          variableWidth: true
        });
      },
      unmatch: function() {
        
      }
    }).register(theme.config.mediaQueries.mediumUp, {
      match: function() {
        if ($('.highlight-image').hasClass('slick-initialized')) {
          $('.highlight-image').slick('unslick');
        }

        $('.highlight-image').slick({
          prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="31" viewBox="0 0 16 31">< g fill="none" fill- rule="evenodd" ><path fill="none" d="M-91-3333h1440v5834H-91z" /><path fill="none" d="M-91-580h1440V558H-91z" /><path fill="#282828" fill-rule="nonzero" d="M13.488 30.71L0 15.355 13.488 0l2.254 1.98L3.993 15.355 15.742 28.73z" /></g ></svg ></button>',
          nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="31" viewBox="0 0 16 31">< g fill="none" fill- rule="evenodd" ><path fill="none" d="M-1333-3333H107v5834h-1440z" /><path fill="none" d="M-1333-580H107V558h-1440z" /><path fill="#282828" fill-rule="nonzero" d="M2.512 30.71L16 15.355 2.512 0 .258 1.98l11.749 13.375L.258 28.73z" /></g ></svg ></button>'
        });
      },
      unmatch: function() {
      }
    });
  }

  return productHighlight;
})();
theme.PageHeroSlider = (function(){
    var selectors = {
        slider: '[page-hero-slick-js]'
    }

    function HeroSlider(container) {
        this.$container = $(container);
        var $slider = $(selectors.slider, this.$container);

       $slider.slick({
            infinite: true,
            dots: false,
            arrows: true,
            prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="40" viewBox="0 0 16 31">< g fill="none" fill- rule="evenodd" ><path fill="none" d="M-91-3333h1440v5834H-91z" /><path fill="none" d="M-91-580h1440V558H-91z" /><path fill="#FFF" fill-rule="nonzero" d="M13.488 30.71L0 15.355 13.488 0l2.254 1.98L3.993 15.355 15.742 28.73z" /></g ></svg ></button>',
            nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="40" viewBox="0 0 16 31">< g fill="none" fill- rule="evenodd" ><path fill="none" d="M-1333-3333H107v5834h-1440z" /><path fill="none" d="M-1333-580H107V558h-1440z" /><path fill="#FFF" fill-rule="nonzero" d="M2.512 30.71L16 15.355 2.512 0 .258 1.98l11.749 13.375L.258 28.73z" /></g ></svg ></button>',
            slidesToShow: 1,
       });
    }

    return HeroSlider;
})();
theme.HomeFeaturedProducts = (function(){
    function HomeFeaturedProducts(container) {
      GeolizrAPI.addEventListener('geolizr.geoData', function(geoData) {
        // Europe Switzerland or Australia
        if ( geoData.currencyCode != 'USD' ){
          $(".product-card__quick-add-trigger, .promo_message").hide();
        }
        if ( geoData.currencyCode == 'EUR' ){
          // $(".product-card__price").addClass('visually-hidden');
          // $(".product-card__international__price").removeClass('visually-hidden');
          // $(".product-info__euro-price").show();
        }
        else if ( geoData.currencyCode == 'CHF' ){
          $(".product-card__price").addClass('visually-hidden');
          $(".product-card__international__price").removeClass('visually-hidden');
          $(".product-info__switz-price").show();
        }
        else if ( geoData.currencyCode == 'AUD' ){
          $(".product-card__price").addClass('visually-hidden');
          $(".product-card__international__price").removeClass('visually-hidden');
          $(".product-info__aus-price").show();
        }
      });
    }
    return HomeFeaturedProducts;
})();

/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#address_form_new');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  $('[js-address-edit]').on('click', function() {
    var formId = $(this).data('form-id');
    $('#address_form_' + formId).toggle();
    $('.account-address__edit').toggle();
    $('.account-address__listing').toggle();
  });

  $('[js-address-delete]').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  
  var config = {
    recoverPasswordForm: '[js-show-recover]',
    hideRecoverPasswordLink: '[js-hide-recover]',
    firstName: '#FirstName',
    lastName: '#LastName'
  };

  var max_chars = 15

  if($(config.firstName).length) {
    $(config.firstName).keydown(function(evt){
      if($(this).val().length > max_chars) {
        $(this).val($(this).val().substr(0, max_chars));
      }
    })

    $(config.firstName).keyup(function(evt){
      if($(this).val().length > max_chars) {
        $(this).val($(this).val().substr(0, max_chars));
      }
    })
  }

  if($(config.lastName).length) {
    $(config.lastName).keydown(function(evt){
      if($(this).val().length > max_chars) {
        $(this).val($(this).val().substr(0, max_chars));
      }
    })

    $(config.lastName).keyup(function(evt){
      if($(this).val().length > max_chars) {
        $(this).val($(this).val().substr(0, max_chars));
      }
    })
  }

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('.login__recover').toggle();
    $('.login__login').toggle();
  }


  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

theme.AccountDashboard = (function(){
  function AccountDashboard(container) {
    this.$container = $(container);
    
    enquire.register(theme.config.mediaQueries.smallDown,{
      match: function(){
        $('#account__orders', this.$container).attr('aria-hidden', true);
        $('[aria-controls="account__orders"]', this.$container).attr('aria-expanded', false);
        $('[aria-controls="account__information"]', this.$container).attr('aria-expanded', true);
      },
      unmatch: function(){
        $('.account__accordion-header', this.$container).attr('aria-expanded', true)
        $('#account__orders, #account__information', this.$container).removeAttr('aria-hidden').removeAttr('style');
      }
    })
  }

  return AccountDashboard;
})();

theme.AccountAddress = (function(){
  function AccountAddress(container) {
    this.$container = $(container);
    
    enquire.register(theme.config.mediaQueries.smallDown,{
      match: function(){
        $('#account-address-new', this.$container).attr('aria-hidden', true);
        $('[aria-controls="account-address-new"]', this.$container).attr('aria-expanded', false);
        $('[aria-controls="account-address-list"]', this.$container).attr('aria-expanded', true);
      },
      unmatch: function(){
        $('.account__accordion-header', this.$container).attr('aria-expanded', true)
        $('#account-address-new, #account-address-list', this.$container).removeAttr('aria-hidden').removeAttr('style')
      }
    })
  }

  return AccountAddress;
})();

theme.AccountOrders = (function(){
  function AccountOrders(container) {
    this.$container = $(container);
    
    enquire.register(theme.config.mediaQueries.smallDown,{
      match: function(){
        $('#account-order__details', this.$container).attr('aria-hidden', true);
        $('[aria-controls="account-order__details"]', this.$container).attr('aria-expanded', false);
        $('[aria-controls="account__order__overview"]', this.$container).attr('aria-expanded', true);
      },
      unmatch: function(){
        $('.account__accordion-header', this.$container).attr('aria-expanded', true)
        $('#account-order__details, #account-order__overview', this.$container).removeAttr('aria-hidden').removeAttr('style')
      }
    })
  }

  return AccountOrders;
})();
theme.StoriesTags = (function(){
    function StoriesTags(container) {
      this.$container = $(container);
      
      enquire.register(theme.config.mediaQueries.smallDown,{
        match: function(){
          $('#blog__stories', this.$container).attr('aria-hidden', true);
          $('[aria-controls="blog__stories"]', this.$container).attr('aria-expanded', false);
        },
        unmatch: function(){
          $('.blog__accordion-header', this.$container).attr('aria-expanded', true)
          $('#blog__stories', this.$container).removeAttr('aria-hidden').removeAttr('style')
        }
      })
    }

    document.addEventListener("DOMContentLoaded", function() {
      var endlessScroll = new Ajaxinate({
        container: '#AjaxinateLoop',
        pagination: '#AjaxinatePagination'
      });
    });

  
    return StoriesTags;
})();
theme.Cart = (function(){
  function Cart(container) {
    this.$container = $(container);

    $.ajax({
      type: 'GET',
      url: '/cart.json',
      async: false,
      success: function(cart){
        var timestamps = []

        $.each(cart.items, function(index, cartItem) {
          var timestamp = cartItem.properties._timestamp
          if(typeof timestamp !== 'undefined' && timestamps.indexOf(timestamp) < 0 && (cartItem.id != 31831600627747 && cartItem.id != 31615688572963)){
            timestamps.push(timestamp);
          }
        })

        $.each(cart.items, function(index, cartItem) {
          if(cartItem.id == 31831600627747 || cartItem.id == 31615688572963){
            if(timestamps.indexOf(cartItem.properties._timestamp) < 0){
              var line = index + 1;
              $.ajax({
                type: 'POST',
                url: '/cart/change.js',
                data: 'quantity=0&line=' + line,
                dataType: 'json',
                async: false,
                success: function(cart){
                }
              })
            }
          }
        })
      }
    })
  }

  return Cart;
})();
theme.TorontoLink = (function(){
    function TorontoLink(container) {
      this.$container = $(container);
      
      GeolizrAPI.addEventListener('geolizr.geoData', function(geoData) {
          if(geoData.countryCode == 'CA') {
              $('.toronto__link-container', this.$container).show();
          }
      });
    }
  
    return TorontoLink;
})();

$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('accordion', theme.Accordion);
  sections.register('product', theme.Product);
  sections.register('collection', theme.Collection);
  sections.register('account-dashboard', theme.AccountDashboard);
  sections.register('account-address', theme.AccountAddress);
  sections.register('account-orders', theme.AccountOrders);
  sections.register('header-section', theme.Header);
  sections.register("swatch", theme.swatches);
  sections.register('hero-slider', theme.HeroSlider);
  sections.register('page-hero-slider', theme.PageHeroSlider);
  sections.register('product-highlight', theme.ProductHighlight);
  sections.register('blog-stories', theme.StoriesTags);
  sections.register('home-featured-products', theme.HomeFeaturedProducts);
  sections.register('ajax-upsell', theme.AjaxUpsell)
  sections.register('cart', theme.Cart)
  sections.register('toronto', theme.TorontoLink);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  // init mobile drawer
  theme.MobileNav.init();
});
var _learnq = _learnq || [];
function addedToCart() {
  fetch(window.location.origin+'/cart.js')
  .then(res => res.clone().json().then(data => {
    var cart = {
      total_price: data.total_price/100,
      $value: data.total_price/100,
      total_discount: data.total_discount,
      original_total_price: data.original_total_price/100,
      items: data.items
    }
    if (item !== 'undefined') {
      cart = Object.assign(cart, item)
    }
    _learnq.push(['track', 'Added to Cart', cart])
  }))
} 
(function (ns, fetch) {
  ns.fetch = function() {
    const response = fetch.apply(this, arguments);
    response.then(res => {
      if (window.location.origin+'/cart/add.js'
      	.includes(res.url)) {
        	addedToCart()
      }
    });
    return response
  }
}(window, window.fetch))
$(document).ajaxComplete(function(event, request, settings){
  console.log(settings)
  if(settings === undefined){
    
  }else{
    if(settings.url == "/cart/add.js"){
      addedToCart()
    }
  }
})
